function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { parse } from 'stack-trace';
import isEmail from 'validator/lib/isEmail';
import { getDataValuesFromUrlKey } from '@shared/utils/dataMappingUtils';
import { optimizeQueryParameters } from '@shared/utils/optimizeUrlHelper';
import { Constants, OfferType, PlanPricingType } from '@shared/utils/constants';
import { PricingStates, UserSegment, OdataRawObjectAppType, ISearchFilterCategory, TermsStrings, AppTag, Badges } from '@shared/Models';
import { getWindow } from '@shared/services/window';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { SharedInstrumentService } from '@shared/services/telemetry/shared/sharedInstrument';
import { DataMap } from '@shared/utils/dataMapping';
import { getAppConfig } from '@shared/services/init/appConfig';
import { Url } from '@shared/services/http/urlUtils';
import * as embedHostUtils from '@embed/embedHostUtils';
import { createAppViewTelemetryLoggedAction, createFeatureFlagsReceivedAction } from '@shared/actions/actions';
import { IFeatureFlags } from '@src/State';
import { extractCampaignsFromUrl, getEntityIdFromUrl, updateHandOffUrlWithCampaignParams } from '@shared/utils/routeUtils';
import { getLocalStorageItem, getSessionStorageItem, hasUserAgreedPrivacyConsent, saveLocalStorageItem, saveSessionStorageItem } from '@shared/utils/browserStorageUtils';
import { isArray, isNullorUndefined } from '@shared/utils/objectUtils';
import { buildHref, routes } from '@shared/routerHistory';
import { getQueryFromBrowserUrl } from '@shared/utils/urlUtils';
import { getTrimmedWords, isEmptyNullorUndefinedString } from '@shared/utils/stringUtils';
import { getPrimaryProductUrl, bitMasksContainSomeBitMask, bitMasksMatch, bitMasksMatchFilter, bitMasksMatchBitMask, productKeyByUrlKey, productKeyByBackendKey, getShortCutBitmask, getProductFilter } from '@shared/utils/datamappingHelpers';
import { loadPartnerManifest } from '@shared/utils/partnerManifestLoader';
import { logger } from '@src/logger';
import { isString } from 'lodash-es';
import { useTelemetry } from '@shared/hooks/useTelemetry';
import sha256 from 'crypto-js/sha256';
import { BusinessTelemetry } from '@shared/utils/businessConstants';
import { isAppContactForm } from '@shared/utils/modals';
import { v4 as uuidv4 } from 'uuid';
// eslint-disable-next-line react-hooks/rules-of-hooks
const [{ flushTelemetryBuffer }] = useTelemetry();
export function generateGuid() {
    return uuidv4(); // random string, no time sequenced.
}
export function attachClickHandlerToElement(id, handler) {
    const el = document.getElementById(id);
    if (el) {
        el.onclick = handler;
    }
}
export const getProductByUrlKey = ({ urlKey })=>{
    const productKey = productKeyByUrlKey[`${urlKey}`];
    return DataMap.products[`${productKey}`];
};
export const getProductByBackendKey = ({ backendKey })=>{
    const productKey = productKeyByBackendKey[`${backendKey}`];
    return DataMap.products[`${productKey}`];
};
export function categoryInfoToBitmask(categoryInfo) {
    const { FilterGroup, FilterID } = categoryInfo || {};
    return categoryInfo ? {
        property: FilterGroup,
        mask: FilterID
    } : null;
}
function getCategoryBitmaskInfo({ collection, dataValueKey, subCollection, dataValueChildKey }) {
    var _DataMap____SubCategoryDataMapping, _DataMap___;
    const categoryInfo = (_DataMap___ = DataMap[`${collection}`][`${subCollection}`][`${dataValueKey}`]) === null || _DataMap___ === void 0 ? void 0 : (_DataMap____SubCategoryDataMapping = _DataMap___.SubCategoryDataMapping) === null || _DataMap____SubCategoryDataMapping === void 0 ? void 0 : _DataMap____SubCategoryDataMapping[`${dataValueChildKey}`];
    return categoryInfoToBitmask(categoryInfo);
}
function getGeneralBitmaskInfo({ collection, dataValueKey }) {
    const categoryInfo = DataMap[`${collection}`][`${dataValueKey}`];
    return categoryInfoToBitmask(categoryInfo);
}
function getIndustriesBitmaskInfo({ collection, dataValueKey, dataValueChildKey }) {
    var _DataMap___SubCategoryDataMapping, _DataMap__;
    const categoryInfo = (_DataMap__ = DataMap[`${collection}`][`${dataValueKey}`]) === null || _DataMap__ === void 0 ? void 0 : (_DataMap___SubCategoryDataMapping = _DataMap__.SubCategoryDataMapping) === null || _DataMap___SubCategoryDataMapping === void 0 ? void 0 : _DataMap___SubCategoryDataMapping[`${dataValueChildKey}`];
    return categoryInfoToBitmask(categoryInfo);
}
const bitmaskInfoType = {
    [Constants.DataMapCollectionKeys.categories]: getCategoryBitmaskInfo,
    [Constants.DataMapCollectionKeys.products]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.industries]: getIndustriesBitmaskInfo,
    [Constants.DataMapCollectionKeys.cloudIndustries]: getIndustriesBitmaskInfo,
    [Constants.DataMapCollectionKeys.serviceTypes]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.trials]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.pricingModel]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.ratings]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.appCompliance]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.azureBenefitEligible]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.copilotExtension]: getGeneralBitmaskInfo,
    [Constants.DataMapCollectionKeys.productType]: getGeneralBitmaskInfo
};
export const getBitMaskInfo = ({ collection, dataValueKey, subCollection, dataValueChildKey })=>{
    const bitmaskType = bitmaskInfoType[`${collection}`];
    return bitmaskType({
        collection,
        dataValueKey,
        subCollection,
        dataValueChildKey
    });
};
export const getProdcutBitMaskInfo = (categoryInfo)=>{
    const { FilterGroup, FilterID } = categoryInfo || {};
    return categoryInfo ? {
        property: FilterGroup,
        mask: FilterID
    } : null;
};
export const isEmbedded = ()=>{
    const AppsourceMode = getWindow().AppsourceMode;
    return AppsourceMode === 'Embed';
};
// Does a reverse look up on the data map from the product display name to get the product key
// Reverse lookup as dont want to create a new map to maintain
export function getProductLongTitleFromDisplayName(displayName) {
    for(const item in DataMap.products){
        // When you iterate over an Enum it gives you both the indexes and the string values
        // The regex makes sure you dont compare the indexes.
        // eslint-disable-next-line no-prototype-builtins
        if (DataMap.products.hasOwnProperty(item) && !/^\d+$/.test(item)) {
            if (displayName === DataMap.products[`${item}`].BackendKey) {
                return DataMap.products[`${item}`].LongTitle;
            }
        }
    }
    // Came here means none the expected products matched,
    // Some one handcrafted the Url with a non existant prod.
    // return an empty string as you cannot show details anyways
    return displayName;
}
// format the string which has {0}, {1} arguments
export function getFormattedString(baseString, args) {
    for(let i = 0; i < args.length; i++){
        // eslint-disable-next-line security/detect-non-literal-regexp
        const regEx = new RegExp('\\{' + i + '\\}', 'gm');
        baseString = baseString.replace(regEx, args[`${i}`]);
    }
    return baseString;
}
export const getTelemetryResponseUrl = (appId)=>{
    const query = {};
    query[Constants.QueryStrings.ApplicationId] = appId;
    query[Constants.QueryStrings.CorrelationId] = getAppConfig('correlationId');
    const url = new Url('/api/notifyresult', query);
    return url.getUrl();
};
export function getPaymentRedirectUrl(entityId, referredBy) {
    const url = new Url(buildHref(routes.checkout, null, {
        entityId
    }, null, null), {
        referredBy
    });
    return url.getUrl();
}
function bitmaskMatch(product, bitmaskValue, products) {
    let match = false;
    if (products) {
        match = bitMasksContainSomeBitMask(bitmaskValue, products);
    } else {
        const productInfo = getProductByUrlKey({
            urlKey: product
        });
        if (product && productInfo) {
            match = bitMasksMatchFilter(bitmaskValue, productInfo);
        }
    }
    return match;
}
// This API returns if a product belongs to office Add-ins
// ShortcutBitmask contains the bitmask value of all the office child products.
// DataMap.products['office365'].ShortcutBitmask = 8355840 which is equal to 'OR' of all the child product filterIds
// we are sending office365 as the primary product for both Saas apps and Saas add-ins. So, added the products param as well
export function isOfficeNonSaasApp(product, products) {
    const productMask = {
        [DataMap.products.AzureforWebApps.FilterGroup]: DataMap.products.AzureforWebApps.FilterID
    };
    return bitmaskMatch(product, getShortCutBitmask(DataMap.products.Office365), products) && !bitmaskMatch(product, productMask, products);
}
// returns the title of the parent product if product belongs to parent product
// checks whether product belongs to parent Product
export function getParentProductTitle(product, parentProduct) {
    const productInfo = getProductByUrlKey({
        urlKey: parentProduct
    });
    if (bitmaskMatch(product, getShortCutBitmask(productInfo))) {
        return productInfo.LongTitle;
    }
}
// This API returns if a product belongs to office Saas apps
// we are sending office365 as the primary product for both Saas apps and Saas add-ins. So, added the products param as well
export function isOfficeSaasApp(product, products) {
    const productOfficeMask = {
        [DataMap.products.Office365.FilterGroup]: DataMap.products.Office365.FilterID
    };
    const productWebAppsMask = {
        [DataMap.products.AzureforWebApps.FilterGroup]: DataMap.products.AzureforWebApps.FilterID
    };
    return bitmaskMatch(product, productOfficeMask, products) && bitmaskMatch(product, productWebAppsMask, products);
}
export const isProduct = ({ app: { primaryProduct }, product })=>{
    const bitmaskVal = getShortCutBitmask(DataMap.products[`${product}`]);
    return bitmaskMatch(getPrimaryProductUrl(primaryProduct), bitmaskVal);
};
// This API returns if a product belongs to office category (Add-ins + Saas apps)
// we are sending office365 as the primary product for both Saas apps and Saas add-ins. So, added the products param as well
export function isOfficeApp(product, products) {
    const bitmaskVal = getShortCutBitmask(DataMap.products.Office365);
    return bitmaskMatch(product, bitmaskVal, products);
}
export function isSaaS(product, products) {
    const bitmaskVal = getShortCutBitmask(DataMap.products.AzureforWebApps);
    return bitmaskMatch(product, bitmaskVal, products);
}
export const isSaaSApp = ({ primaryProduct })=>{
    return isSaaS(getPrimaryProductUrl(primaryProduct));
};
export function isD365(product, products) {
    const bitmaskVal = getShortCutBitmask(DataMap.products.Dynamics365);
    return bitmaskMatch(product, bitmaskVal, products);
}
export const isD365App = ({ primaryProduct })=>{
    return isD365(getPrimaryProductUrl(primaryProduct));
};
export function isD365BC(product, products) {
    const bitmaskVal = getShortCutBitmask(DataMap.products.Dynamics365forBusinessCentral);
    return bitmaskMatch(product, bitmaskVal, products);
}
export const isD365BCApp = ({ primaryProduct })=>{
    return isD365BC(getPrimaryProductUrl(primaryProduct));
};
export const isPowerBIVisuals = (product, products)=>{
    const bitmaskVal = getShortCutBitmask(DataMap.products.PowerBICustomVisual);
    return bitmaskMatch(product, bitmaskVal, products);
};
export const isPowerBIVisualsApp = ({ primaryProduct })=>{
    return isPowerBIVisuals(getPrimaryProductUrl(primaryProduct));
};
export function isPowerBI(product, products) {
    const bitmaskVal = getShortCutBitmask(DataMap.products.PowerBI);
    return bitmaskMatch(product, bitmaskVal, products);
}
export const isPowerBIApp = ({ primaryProduct })=>{
    return isPowerBI(getPrimaryProductUrl(primaryProduct));
};
export function isAzure(product, products) {
    const bitmaskVal = getShortCutBitmask(DataMap.products.Azure);
    return bitmaskMatch(product, bitmaskVal, products);
}
export function isAzureApp({ primaryProduct }) {
    return isAzure(getPrimaryProductUrl(primaryProduct));
}
export const getProductHandoffTitle = ({ primaryProduct })=>{
    const product = getProductFilter(primaryProduct);
    return product === null || product === void 0 ? void 0 : product.HandoffTitle;
};
/** This is a temporary function.
 * AppSource has to support offers from Office and from BigCat during the migration.
 * Once all offers have been migrated, this function and all references to it can be deleted. */ export function isMigratedPowerBIVisual(appInfo) {
    return appInfo && appInfo.downloadLink && appInfo.downloadSampleLink && appInfo.bigId;
}
export function shouldDownloadPowerBIVisual(appInfo, isEmbedded) {
    return appInfo && isPowerBIVisuals(getPrimaryProductUrl(appInfo.primaryProduct)) && isMigratedPowerBIVisual(appInfo) && !isEmbedded;
}
export function isTransactableOfferType(app) {
    return app && [
        isSaaSApp,
        isD365App,
        isD365BCApp,
        isPowerBIVisualsApp
    ].some((fn)=>fn(app));
}
export function isLTS(app) {
    var _app_pricingInformation_skus, _app_pricingInformation;
    return (_app_pricingInformation = app.pricingInformation) === null || _app_pricingInformation === void 0 ? void 0 : (_app_pricingInformation_skus = _app_pricingInformation.skus) === null || _app_pricingInformation_skus === void 0 ? void 0 : _app_pricingInformation_skus.find((sku)=>{
        var _sku_termPrices;
        return (_sku_termPrices = sku.termPrices) === null || _sku_termPrices === void 0 ? void 0 : _sku_termPrices.find((termPrice)=>termPrice.unit === TermsStrings.Term2YString || termPrice.unit === TermsStrings.Term3YString || termPrice.unit === TermsStrings.Term4YString || termPrice.unit === TermsStrings.Term5YString || termPrice.billingPlan);
    });
}
export const isTransactApp = ({ isEmbedded, ctaTypes, appData, billingRegion })=>{
    return !isEmbedded && appData && (ctaTypes === null || ctaTypes === void 0 ? void 0 : ctaTypes.some((ctaType)=>[
            Constants.CTAType.Purchase,
            Constants.CTAType.BuyLicense
        ].includes(ctaType))) && billingRegion && isTransactableOfferType(appData);
};
/** An offer is considered BAG transactable if it:
 *  - Is of offer type Dynamics 365 CE, Dynamics 365 BC or Power BI Visuals
 *  - Has prices associated with the offer
 */ export const isBagTransactable = (appData)=>{
    const primaryProductUrl = getPrimaryProductUrl(appData === null || appData === void 0 ? void 0 : appData.primaryProduct);
    const isBagEnabledD365BC = isD365BC(primaryProductUrl);
    const isBagEnabledD365 = isD365(primaryProductUrl) && primaryProductUrl !== 'dynamics-365-business-central';
    const isBagEnabledPowerBIVisual = isPowerBIVisuals(primaryProductUrl);
    const isBagOfferType = isBagEnabledD365 || isBagEnabledD365BC || isBagEnabledPowerBIVisual;
    return isBagOfferType && appData.hasPrices;
};
export function getTransactCTATypes(targetApp, uiRole, doesTenantHasLicenseForApp, isEmbedded, billingRegion) {
    var _targetApp_licenseManagement;
    const ctaTypes = [];
    const isAdmin = uiRole === Constants.UiRole.Admin;
    if (isBagTransactable(targetApp)) {
        var _targetApp_licenseManagement1;
        /* Only administrator can install D365CE apps for users in tenant.
      Administrator and Non-Administrator can install D365BC apps for users in tenant if it has licenses.
      Any user can install Power BI Visuals, since they are all Freemium.
      If the offer is Freemium, Install must be the primary action.
    */ const showInstallFirst = isD365(getPrimaryProductUrl(targetApp === null || targetApp === void 0 ? void 0 : targetApp.primaryProduct)) && isAdmin && (targetApp === null || targetApp === void 0 ? void 0 : (_targetApp_licenseManagement1 = targetApp.licenseManagement) === null || _targetApp_licenseManagement1 === void 0 ? void 0 : _targetApp_licenseManagement1.isFreemium) || isPowerBIVisuals(getPrimaryProductUrl(targetApp === null || targetApp === void 0 ? void 0 : targetApp.primaryProduct));
        const isD365BCApp = isD365BC(getPrimaryProductUrl(targetApp === null || targetApp === void 0 ? void 0 : targetApp.primaryProduct));
        if (!isD365BCApp && showInstallFirst) {
            ctaTypes.push(Constants.CTAType.Install);
            ctaTypes.push(Constants.CTAType.BuyLicense);
        } else if (!isD365BCApp && isAdmin && doesTenantHasLicenseForApp || isD365BCApp && doesTenantHasLicenseForApp) {
            ctaTypes.push(Constants.CTAType.BuyLicense);
            ctaTypes.push(Constants.CTAType.Install);
        } else {
            ctaTypes.push(Constants.CTAType.BuyLicense);
        }
    } else if (isPowerBIVisuals(getPrimaryProductUrl(targetApp === null || targetApp === void 0 ? void 0 : targetApp.primaryProduct))) {
        ctaTypes.push(Constants.CTAType.Get);
    } else if (targetApp === null || targetApp === void 0 ? void 0 : (_targetApp_licenseManagement = targetApp.licenseManagement) === null || _targetApp_licenseManagement === void 0 ? void 0 : _targetApp_licenseManagement.isMicrosoftManaged) {
        const showGetCta = targetApp.licenseManagement.isFreemium || doesTenantHasLicenseForApp;
        if (isAdmin && showGetCta) {
            ctaTypes.push(Constants.CTAType.Get);
            ctaTypes.push(Constants.CTAType.RequestTrial);
        } else {
            ctaTypes.push(Constants.CTAType.RequestTrial);
        }
    }
    const isTransactableD365App = isD365(getPrimaryProductUrl(targetApp === null || targetApp === void 0 ? void 0 : targetApp.primaryProduct)) && isTransactApp({
        isEmbedded,
        ctaTypes: targetApp.ctaTypes,
        appData: targetApp,
        billingRegion
    });
    if (isTransactableD365App) {
        ctaTypes.push(Constants.CTAType.RequestTrial);
    }
    return ctaTypes.length ? ctaTypes : null;
}
export function getCtaBagTransactable(uiRole, doesTenantHasLicenseForApp, isFreemium) {
    const isAdmin = uiRole === Constants.UiRole.Admin;
    const { CTAType: { Install, BuyLicense } } = Constants;
    if (isAdmin && (doesTenantHasLicenseForApp || isFreemium)) {
        return Install;
    } else {
        return BuyLicense;
    }
}
export function isSharepointApp(products) {
    return bitMasksMatchBitMask(products, getProdcutBitMaskInfo(DataMap.products.SharePoint));
}
export function isLeadGenEnabled(appData) {
    return appData.leadgenEnabled !== undefined ? appData.leadgenEnabled : null;
}
function getOfficeHandoffParams(appId, correlationId, locale) {
    const urlArgs = [];
    // These values for auth type are given by Office Store team
    const storeConfig = getAppConfig('config');
    // default values
    let ui = 'en-us';
    // 'locale' also denote the content market applicable for the app.
    // This can be removed once we build support for localization.
    let contentMarket = locale || 'en-us';
    if (storeConfig === null || storeConfig === void 0 ? void 0 : storeConfig.locale) {
        contentMarket = ui = storeConfig.locale;
    }
    // This is the URL which we are trying to fill the parameters for: https://pages.store.office.com/addininstaller.aspx?assetid={0}&ui={1}&rs={2}&sourcecorrid={3}
    urlArgs.push(appId);
    urlArgs.push(ui); // ui => UI language
    urlArgs.push(contentMarket); // rs => Content Market
    urlArgs.push(correlationId);
    return urlArgs;
}
export function getHandoffUrlForProduct(productUrlKey, appId, products, locale) {
    const config = loadPartnerManifest();
    const handOffUrl = config.handoff[`${productUrlKey}`];
    // For office Saas apps, we use the default handoff url which we receive from the backend
    // For Power BI Visuals, we no longer route externally to Office
    if (!handOffUrl || isOfficeSaasApp(productUrlKey, products)) {
        return null;
    }
    const correlationId = getAppConfig('correlationId');
    let urlArgs = [];
    if (isOfficeApp(productUrlKey)) {
        urlArgs = getOfficeHandoffParams(appId, correlationId, locale);
    } else {
        urlArgs = [
            encodeURIComponent(appId),
            encodeURIComponent(getTelemetryResponseUrl(appId)),
            correlationId
        ];
    }
    const handOffURL = getFormattedString(handOffUrl, urlArgs);
    return handOffURL;
}
export function getHandOffUrlFromPartnerManifest({ primaryProduct, entityId, products, locale }) {
    return getHandoffUrlForProduct(getPrimaryProductUrl(primaryProduct), entityId, products, locale);
}
export function getHandoffUrlFromApp({ handoffURL }) {
    if (!handoffURL) {
        return;
    }
    const notifyURL = getTelemetryResponseUrl(handoffURL);
    const url = new URL(handoffURL);
    url.searchParams.set('responseUrl', notifyURL);
    return url.toString();
}
export function getHandoffUrl(app) {
    if (!app) {
        return;
    }
    const url = getHandOffUrlFromPartnerManifest(app) || getHandoffUrlFromApp(app);
    return updateHandOffUrlWithCampaignParams(url);
}
export function getHandoffTitle(app) {
    if (!app) {
        return;
    }
    const { title, primaryProduct } = app;
    const productHandoffTitle = getProductHandoffTitle({
        primaryProduct
    });
    if (productHandoffTitle) {
        return productHandoffTitle;
    }
    return title;
}
export function isPrivateOffer(appType) {
    if (appType === OdataRawObjectAppType.private) {
        return true;
    }
    return false;
}
export function isOpenInNewWindowButton({ isEmbedded, ctaType, appData, billingRegion, url }) {
    const isTransactable = isTransactApp({
        isEmbedded,
        ctaTypes: [
            ctaType
        ],
        appData,
        billingRegion
    }) || isPrivateOffer(appData === null || appData === void 0 ? void 0 : appData.appType);
    return(// Product decision that for test drive we always show the "open in new tab" icon.
    // We couldn't know if the test drive will send the user outside before the button is created
    ctaType === Constants.CTAType.TestDrive || !!url && !isAppContactForm(appData, ctaType) && !isTransactable && !shouldDownloadPowerBIVisual(appData, isEmbedded) && !isEmbedded);
}
export function getDataMapValues(collection, bitmask) {
    return Object.keys(collection).reduce((acc, value)=>{
        if (bitMasksMatchFilter(bitmask, collection[`${value}`])) {
            acc.push(collection[`${value}`]);
        }
        return acc;
    }, []);
}
export function getProductFieldFromDataMap(collection, bitmask, field) {
    const dataMapValues = getDataMapValues(collection, bitmask);
    return dataMapValues ? dataMapValues[0][`${field}`] : '';
}
export function getActionStringForCTAType(ctaType) {
    // Falling back to Get if we ctaType does not match.
    return Constants.ActionStrings[Constants.CTAType[`${ctaType}`]];
}
// Utility function to determine if an email has 'onmicrosoft.com' or 'ccsctp.net' [email sufixes for PROD/DF and INT respectively]
export function isOnMicrosoftEmail(email) {
    return !!(email && (email.substr(-'onmicrosoft.com'.length) === 'onmicrosoft.com' || email.substr(-'ccsctp.net'.length) === 'ccsctp.net'));
}
export function getLeadGenEmailId(userInfo) {
    return userInfo.email && userInfo.alternateEmail && isOnMicrosoftEmail(userInfo.email) && userInfo.alternateEmail !== 'undefined' ? userInfo.alternateEmail : userInfo.email;
}
const urlList = [
    'https://powerbi-df.analysis-df.windows.net',
    'https://dxt.powerbi.com',
    'https://msit.powerbi.com',
    'https://app.powerbi.com',
    'https://app.powerbi.cn',
    'https://app.powerbigov.us',
    'https://app.powerbi.de',
    'https://app.analysis.windows-int.net',
    'https://home.dynamics.com',
    'https://tip1.home.dynamics.com',
    'https://tip1.web.powerapps.com',
    'https://powerapps.cloudapp.net',
    'https://portal.analysis.windows-int.net',
    'https://appgallery.spza-internal.net',
    'https://appgallery.spza-staging.net',
    'http://localhost:3000',
    'https://service.powerapps.com',
    'https://dxtcurrent.powerbi.com',
    'https://dxtprevious.powerbi.com',
    'https://dxtnext.powerbi.com',
    'https://cosell.dev.microsoft.com',
    'https://cosell.ppe.microsoft.com',
    'https://cosell.microsoft.com',
    'https://partnersalespreview.microsoft.com',
    'https://partnersales.microsoft.com'
];
const httpsSubString = 'https://';
export function checkOriginSource(endpoint) {
    if (!endpoint) {
        return false;
    }
    let origin = endpoint;
    let originStartIndex = 0;
    if (origin.indexOf(httpsSubString) === 0) {
        originStartIndex = httpsSubString.length;
    }
    const firstSlashIndex = origin.indexOf('/', originStartIndex);
    if (firstSlashIndex >= 0) {
        origin = origin.substr(0, firstSlashIndex);
    }
    for(let i = 0; i < urlList.length; i++){
        if (origin.toLocaleLowerCase() === urlList[`${i}`]) {
            return true;
        }
    }
    if (/^https:\/\/.*analysis.windows(-int)?.net/.test(origin) || // PowerBI (daily) env
    /^https:\/\/.*.dynamics.com/.test(origin) || // Dynamics CRM
    /^https:\/\/.*.dynamics.de/.test(origin) || // Dinamics CRM
    /^https:\/\/.*.financials.dynamics-tie.com/.test(origin) || /^https:\/\/.*.financials.dynamics-ppe.com/.test(origin) || /^https:\/\/.*.projectmadeira.com/.test(origin) || // Madeira PROD
    /^https:\/\/.*.projectmadeira-ppe.com/.test(origin) || // Madeira INT
    /^https:\/\/.*.projectmadeira-test.com/.test(origin)) {
        // Madeira test
        return true;
    } else {
        return false;
    }
}
export function removeURLParameter(url, parameter) {
    // Split the url into 2 parts. The right side of the '?' has all the query parameters.
    const urlparts = url.split('?');
    if (urlparts.length >= 2) {
        const prefix = encodeURIComponent(parameter) + '=';
        // We use either '&' or ';' as the parameter seperaters. Use the second part of the urlParts which has queryParams
        const queryParams = urlparts[1].split(/[&;]/g);
        for(let i = queryParams.length; i-- > 0;){
            // Search the string for the last occurance of the prefix : Equivalent of string starts with
            if (queryParams[`${i}`].lastIndexOf(prefix, 0) !== -1) {
                queryParams.splice(i, 1); // Removes that element from the queryParams array
            }
        }
        const newUrl = urlparts[0] + (queryParams.length > 0 ? '?' + queryParams.join('&') : '');
        return newUrl;
    } else {
        return url;
    }
}
// Telemetry Helper Functions
export function getDataMapString(collection, bitmask, field) {
    const dataMapValues = getDataMapValues(collection, bitmask);
    const result = dataMapValues.map((value)=>{
        return value[`${field}`];
    }).join(', ');
    return result;
}
export function getProductStringArray(productBitmask) {
    const productUrlKeyString = getDataMapString(DataMap.products, productBitmask, 'UrlKey');
    return getTrimmedWords(productUrlKeyString, ',');
}
/**
 * get consent dialog info for telemetry detail content
 *
 * @param hasCheckBox consent Dialog has consent checkbox: e.x. By click this ...
 * @param hasUserProfile consent Dialog has user profile: e.x. name, email, phone, job, company, ...
 *
 * @return
 *     an object which has following properties
 *         hasPhone: boolean determine whether dialog has phone or not
 *         hasCheckbox: boolean determine whether dialog has checkbox or not
 */ export function getTelemetryDetailContentConsentDialogInfo(hasCheckbox = false, hasUserProfile = false) {
    const consentDialogInfo = {
        hasContactInfo: isNullorUndefined(hasUserProfile) ? undefined : hasUserProfile,
        hasCheckbox: isNullorUndefined(hasCheckbox) ? undefined : hasCheckbox
    };
    return consentDialogInfo;
}
function getTag(keys) {
    return keys.map((key)=>AppTag[`${key}`]);
}
export function isCertifiedSoftware(app) {
    var _app_badges;
    return !!(app === null || app === void 0 ? void 0 : (_app_badges = app.badges) === null || _app_badges === void 0 ? void 0 : _app_badges.includes(Badges.MAICPPCertifiedSolution));
}
export function isFreeTrial(app) {
    var _app_startingPrice, _app_pricingInformation;
    if (app.actionString === Constants.ActionStrings.Try) {
        return true;
    }
    // simple plan has startingPrice
    if ((_app_startingPrice = app.startingPrice) === null || _app_startingPrice === void 0 ? void 0 : _app_startingPrice.hasFreeTrial) {
        return true;
    }
    return (_app_pricingInformation = app.pricingInformation) === null || _app_pricingInformation === void 0 ? void 0 : _app_pricingInformation.skus.some((sku)=>sku.freeTrialDurationDays);
}
function isMicrosoftCertified({ CertificationState }) {
    return CertificationState === Constants.CertificationType.MicrosoftCertified;
}
function isPreferredSolution({ isSolutionMap = false }) {
    return isSolutionMap || false;
}
function isOfficeAwards({ tags, entityId }) {
    return (tags === null || tags === void 0 ? void 0 : tags.length) && getTag(tags)[0] === AppTag.OfficeAward || (entityId === null || entityId === void 0 ? void 0 : entityId.toUpperCase()) === Constants.HyperfishEntityId.toUpperCase();
}
function isPBICertified({ tags }) {
    return (tags === null || tags === void 0 ? void 0 : tags.length) && getTag(tags)[0] === AppTag.PowerBICertified;
}
function isAzureExpertsMSP({ tags }) {
    return tags === null || tags === void 0 ? void 0 : tags.includes(Constants.BadgeType.AzureExpertsMSP);
}
function isPrivateOfferBadge({ appType = OdataRawObjectAppType.public }) {
    return isPrivateOffer(appType);
}
function isAzureBenefitEligible({ AzureBenefitEligible = 0 }) {
    return AzureBenefitEligible !== 0;
}
const badgesConditions = {
    [Constants.BadgeType.MicrosoftCertified]: isMicrosoftCertified,
    [Constants.BadgeType.PreferredSolution]: isPreferredSolution,
    [Constants.BadgeType.OfficeAwards]: isOfficeAwards,
    [Constants.BadgeType.PBICertified]: isPBICertified,
    [Constants.BadgeType.AzureExpertsMSP]: isAzureExpertsMSP,
    [Constants.BadgeType.PrivateOffer]: isPrivateOfferBadge,
    [Constants.BadgeType.AzureBenefitEligible]: isAzureBenefitEligible,
    [Constants.BadgeType.CertifiedSoftware]: isCertifiedSoftware,
    [Constants.BadgeType.FreeTrial]: isFreeTrial
};
export function getBadgeTypes(appData) {
    return Object.entries(badgesConditions).filter(([, condition])=>condition(appData)).map(([badge])=>badge);
}
/**
 * get application telemetry detail content as string
 *
 * @param appInfo: application information
 * @param isNationalCloud: detetmine this application is Microsoft National Clouds: e.g. Azure, Dynamics 365, and Office 365
 * @param ctaTypes: click to action types
 * @param consentDialogHasUserProfile: if current view is a consent modal dialog, determine it has user contact information
 * @param consentDialogHasCheckbox: if current view is a consent modal dialog, determine it has checkbox
 *
 * @return:
 *  a string serialized for telemetry property details
 */ export function getAppTelemetryDetailContentText({ appInfo, isNationalCloud, isEmbedded, ctaTypes, consentDialogHasUserProfile, consentDialogHasCheckbox, currentView, tileDataRequestId, uiRole, hasLicense, shouldShowUserTerms, planId, ribbonKey, trailId }) {
    if (!appInfo) {
        return '';
    }
    const { privateApp, leadgenEnabled: leadGenEnabled, title, builtFor, actionString, licenseManagement, entityId, offerType, startingPrice, products, publisher, publisherId } = appInfo;
    // data map, e.g. filter, property 'Title'
    const dataMapField = 'Title';
    const appPublisher = publisher && isNationalCloud ? sha256(publisher).toString() : publisher;
    const appPublisherId = publisherId && isNationalCloud ? sha256(publisherId).toString() : publisherId;
    const ctaTypeString = isArray(ctaTypes) && ctaTypes.map((ctaType)=>Constants.CTAType[`${ctaType}`]).join(', ') || undefined;
    const badgeTypes = getBadgeTypes(appInfo);
    const productAvailabilityType = privateApp ? BusinessTelemetry.ProductAvailabilityType.Private : BusinessTelemetry.ProductAvailabilityType.Public;
    const isSaasTransactApp = offerType === OfferType.SaaSApp ? startingPrice && typeof startingPrice.pricingData === 'object' ? 'true' : 'false' : '';
    const isTransactable = startingPrice && typeof startingPrice.pricingData === 'object' ? 'true' : 'false';
    const appTelemetryDetailContent = {
        title,
        publisher: appPublisher,
        builtFor,
        actionString,
        products: getDataMapString(DataMap.products, products, dataMapField),
        leadGenEnabled,
        ctaType: ctaTypeString,
        type: productAvailabilityType,
        currentView,
        tileDataRequestId: tileDataRequestId || '',
        isSaasTransactApp,
        isEmbedded,
        isTransactable,
        isMicrosoftManaged: licenseManagement === null || licenseManagement === void 0 ? void 0 : licenseManagement.isMicrosoftManaged,
        isFreemium: licenseManagement === null || licenseManagement === void 0 ? void 0 : licenseManagement.isFreemium,
        uiRole,
        hasLicense,
        showTerms: shouldShowUserTerms,
        badgeTypes,
        publisherId: appPublisherId,
        entityId,
        planId,
        ribbonKey,
        trailId
    };
    // if any of consentDialogHasUserProfile and consentDialogHasCheckbox has value
    // add consent dialog info into telemetry detail content
    if (!isNullorUndefined(consentDialogHasUserProfile) || !isNullorUndefined(consentDialogHasCheckbox)) {
        const consentDialogInfoKey = 'consentDialogInfo';
        appTelemetryDetailContent[`${consentDialogInfoKey}`] = getTelemetryDetailContentConsentDialogInfo(consentDialogHasCheckbox, consentDialogHasUserProfile);
    }
    return JSON.stringify(appTelemetryDetailContent);
}
/**
 * get consulting service telemetry detail content as string
 *
 * @param serviceInfo: consulting service information
 * @param isNationalCloud: detetmine this application is Microsoft National Clouds: e.g. Azure, Dynamics 365, and Office 365
 * @param ctaTypes: click to action types
 * @param consentDialogHasUserProfile: if current view is a consent modal dialog, determine it has user contact information
 * @param consentDialogHasCheckbox: if current view is a consent modal dialog, determine it has checkbox
 * @param currentView: name of main container component rendered in current page, e.x. 'galleryPage'
 *
 * @return:
 *  a string serialized for telemetry property details
 */ export function getServiceTelemetryDetailContentText({ serviceInfo, isNationalCloud, ctaTypes, consentDialogHasUserProfile, consentDialogHasCheckbox, currentView, ribbonKey = '', trailId }) {
    if (!serviceInfo) {
        return '';
    }
    const { serviceTypes, title, industries, products, publisher, entityId, publisherId } = serviceInfo;
    // data map, e.g. filter, property 'Title'
    const dataMapField = 'Title';
    const ctaTypeString = isArray(ctaTypes) && ctaTypes.map((ctaType)=>Constants.CTAType[`${ctaType}`]).join(', ') || undefined;
    const appPublisher = publisher && isNationalCloud ? sha256(publisher).toString() : publisher;
    const appPublisherId = publisherId && isNationalCloud ? sha256(publisherId).toString() : publisherId;
    const serviceTelemetryDetailContent = {
        serviceName: title,
        publisher: appPublisher,
        actionString: Constants.ActionStrings.Service,
        products: getDataMapString(DataMap.products, products, dataMapField),
        industries: getDataMapString(DataMap.industries, industries, dataMapField),
        serviceTypes: Constants.ServiceTypes[`${serviceTypes}`],
        ctaType: ctaTypeString,
        currentView,
        entityId,
        publisherId: appPublisherId,
        ribbonKey,
        trailId
    };
    // if any of consentDialogHasUserProfile and consentDialogHasCheckbox has value
    // add consent dialog info into telemetry detail content
    if (!isNullorUndefined(consentDialogHasUserProfile) || !isNullorUndefined(consentDialogHasCheckbox)) {
        const consentDialogInfoKey = 'consentDialogInfo';
        serviceTelemetryDetailContent[`${consentDialogInfoKey}`] = getTelemetryDetailContentConsentDialogInfo(consentDialogHasCheckbox, consentDialogHasUserProfile);
    }
    return JSON.stringify(serviceTelemetryDetailContent);
}
export function isEmbedHostDataDynamic(embedHost) {
    if (embedHost === DataMap.products.PowerBI.UrlKey) {
        return true;
    }
    return false;
}
export function getEmbedHostName(embedHost) {
    var _getProductByUrlKey;
    return embedHost != null ? (_getProductByUrlKey = getProductByUrlKey({
        urlKey: embedHost
    })) === null || _getProductByUrlKey === void 0 ? void 0 : _getProductByUrlKey.UrlKey : 'portal';
}
export function compareApiVersion(sourceVersion, targetVersion) {
    return sourceVersion < targetVersion ? -1 : sourceVersion > targetVersion ? 1 : 0;
}
export function IsMoonCakeNationalCloud(nationalCloud) {
    if (nationalCloud) {
        if (nationalCloud.toLowerCase() === Constants.mooncakeNationalCloud) {
            return true;
        }
    }
    return false;
}
function getProductPropertyByProductKey(productKey, value, propertyName) {
    for(const key in DataMap.products){
        if (!!DataMap.products[`${key}`] && DataMap.products[`${key}`][`${productKey}`] === value) {
            return DataMap.products[`${key}`][`${propertyName}`];
        }
    }
    return null;
}
export function getProductBackendKeyByLongTitle(productTitle) {
    return getProductPropertyByProductKey('LongTitle', productTitle, 'BackendKey');
}
export function serializeUserProfileEmbedInfo(userInfo) {
    let profileToSave = '';
    for(const key in userInfo){
        if (key === Constants.userAcceptField) {
            continue;
        }
        profileToSave += key + ':' + userInfo[`${key}`] + '|';
    }
    return profileToSave;
}
export function readUserProfileEmbedCookie(userProfileInCookie, user) {
    const userProfileInfo = userProfileInCookie.split('|');
    userProfileInfo.forEach((pair)=>{
        const colenIndex = pair.indexOf(':');
        if (colenIndex !== -1) {
            const key = pair.substring(0, colenIndex);
            const value = pair.substring(colenIndex + 1, pair.length);
            user[`${key}`] = value;
        }
    });
}
export function logClientError(err, additionalDetails, file = '', isWarning = false) {
    try {
        var _getWindow_location, _getWindow;
        const value = err ? parse(err) : [];
        const stringifiedStack = value.map((sf)=>sf.toString()).join('\n');
        let errorMessage = '';
        if (err && err.message) {
            errorMessage = `Error Message: ${err.message}\n `;
        }
        additionalDetails = errorMessage + additionalDetails + '\n Stack: ' + stringifiedStack;
        // adding the file to query errors based on the ones that have a valid file path hence raised from our code base vs ones raised by external components
        const details = {
            file,
            additionalDetails
        };
        console.error(err);
        const payload = {
            page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
            action: Constants.Telemetry.Action.PageLoad,
            actionModifier: isWarning ? Constants.Telemetry.ActionModifier.Warning : Constants.Telemetry.ActionModifier.Error,
            details: JSON.stringify(details),
            flushLog: true
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        const log = isWarning ? logger.warning.bind(logger) : logger.error.bind(logger);
        log(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    } catch (error) {
        console.error(error);
    }
}
// Utility function which determines if a string is a JSON or not.
// Added this to avoid crash in few cases where we receive an object instead of a json string.
export function isJsonString(str) {
    let parsedObj = null;
    try {
        parsedObj = JSON.parse(str);
    } catch (e) {
        return null;
    }
    return parsedObj;
}
// function to loop through feature flags
// and check if at least one of them is present in the queries or in the app settings
export function queryConfigContainsFeatureFlags(queryParams) {
    const featureFlags = new IFeatureFlags();
    const keys = Object.getOwnPropertyNames(featureFlags);
    const keysLength = keys.length;
    for(let i = 0; i < keysLength; i++){
        if (queryParams && queryParams[keys[`${i}`]]) {
            return true;
        } else if (process.env[keys[`${i}`]]) {
            return true;
        }
    }
    return false;
}
// function to loop through feature flags
// and return an object with featureFlag values that are present in the query or in the app settings
// while ignoring other params in the query
export function getParsedFeatureFlags(queryParams) {
    const result = new IFeatureFlags();
    if (queryParams) {
        const keys = Object.getOwnPropertyNames(result);
        const keysLength = keys.length;
        for(let i = 0; i < keysLength; i++){
            const ff = keys[`${i}`];
            if (queryParams[`${ff}`]) {
                if (typeof result[`${ff}`] === 'boolean') {
                    result[`${ff}`] = queryParams[`${ff}`] === 'true';
                } else {
                    result[`${ff}`] = queryParams[`${ff}`];
                }
            } else if (process.env[`${ff}`]) {
                result[`${ff}`] = process.env[`${ff}`];
            }
        }
    }
    result.activeCloudMarketplaceFeatures();
    return result;
}
// returns true or false whether the regular expression matches pattern
export function matchesExpression(spzaUserId, pattern) {
    const match = spzaUserId.match(pattern);
    if (match) {
        return match.index === 0;
    }
    return false;
}
export function getSpzaUserIdAndNewUserModifier() {
    const spzaUserData = {
        spzaUserId: '',
        newUserModifier: Constants.Telemetry.ActionModifier.SpzaUserIdNew
    };
    // get spza user id
    spzaUserData.spzaUserId = getLocalStorageItem(Constants.LocalStorage.spzaUserId);
    // create spza user id
    if (isEmptyNullorUndefinedString(spzaUserData.spzaUserId)) {
        // NOTE: if local storage is not enabled in browser, we always create a new one everytime we access it
        spzaUserData.spzaUserId = generateGuid();
        // store spza user id
        saveLocalStorageItem(Constants.LocalStorage.spzaUserId, spzaUserData.spzaUserId);
    } else if (hasUserAgreedPrivacyConsent()) {
        // a returned user must meet following criteria
        //  1) user has agreed privacy agreement <=> spzaUserId is in browser local storage, and
        //  2) spzaUserId is found
        spzaUserData.newUserModifier = Constants.Telemetry.ActionModifier.SpzaUserIdReturn;
    }
    return spzaUserData;
}
export function getTrailIdAndData(forceUpdate = false, action) {
    // get spza user trail id
    const data = JSON.parse(getSessionStorageItem(Constants.LocalStorage.trailId) || JSON.stringify({}));
    const trailData = _object_spread({
        trailId: '',
        trailIdModifier: Constants.Telemetry.ActionModifier.TrailIdUpdate,
        time: Date.now().toString()
    }, data);
    const sessionTimeOut = 1000 * 60 * 60 * 2; // 2h
    const isValid = new Date(parseInt(trailData.time)).getTime() + sessionTimeOut > Date.now();
    // create user trail id
    if (isEmptyNullorUndefinedString(trailData.trailId) || !isValid || forceUpdate) {
        trailData.trailId = `${generateGuid()}_${trailData.time}`;
        // store trail id
        saveSessionStorageItem(Constants.LocalStorage.trailId, JSON.stringify(trailData));
        if (forceUpdate) {
            trailData.trailIdModifier = `${Constants.Telemetry.ActionModifier.TrailIdUpdate} by force duo to ${action}`;
            SpzaInstrumentService.registerTrailId(trailData.trailId);
        }
        console.log('[TrailID]', trailData.trailId, trailData.trailIdModifier);
    } else if (hasUserAgreedPrivacyConsent()) {
        trailData.trailIdModifier = Constants.Telemetry.ActionModifier.TrailIdValid;
    }
    const payload = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.TrailData,
        actionModifier: trailData.trailIdModifier,
        details: JSON.stringify(trailData)
    };
    SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier
    });
    return trailData;
}
export function getLocaleDate(date, locale) {
    const options = {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    };
    if (date) {
        const parsedDate = new Date(date);
        return locale ? parsedDate.toLocaleDateString(locale, options) : parsedDate.toLocaleDateString();
    }
    return '';
}
export function getNetworkStats() {
    var _navigator;
    const { effectiveType, rtt, downlink } = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.connection) || {};
    return {
        downlink,
        rtt,
        effectiveType
    };
}
export function logAssetsTelemetryEvents(store) {
    var _state_config, _state_config1, _getWindow_performance, _getWindow, _getWindow_performance1, _getWindow1;
    const state = store.getState();
    const instrument = SpzaInstrumentService.getProvider();
    const page = getWindow().location.href;
    const landingView = state === null || state === void 0 ? void 0 : (_state_config = state.config) === null || _state_config === void 0 ? void 0 : _state_config.currentView;
    const isEmbedded = ((_state_config1 = state.config) === null || _state_config1 === void 0 ? void 0 : _state_config1.isEmbedded) || false;
    const connection = getNetworkStats();
    const userAgent = navigator.userAgent;
    const additionalTelemetry = {
        landingView,
        isEmbedded,
        connection,
        userAgent
    };
    const { navigationStart = 0, requestStart = 0 } = ((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_performance = _getWindow.performance) === null || _getWindow_performance === void 0 ? void 0 : _getWindow_performance.timing) || {};
    const perfEntries = ((_getWindow1 = getWindow()) === null || _getWindow1 === void 0 ? void 0 : (_getWindow_performance1 = _getWindow1.performance) === null || _getWindow_performance1 === void 0 ? void 0 : _getWindow_performance1.getEntriesByType('resource')) || [];
    perfEntries.filter(({ initiatorType })=>initiatorType === 'script' || initiatorType === 'link').forEach((perfEntry)=>{
        const { name: src, initiatorType, responseEnd: performanceNow, duration } = perfEntry;
        const telemetryData = {
            page,
            action: Constants.Telemetry.Action.PerfResources,
            actionModifier: Constants.Telemetry.ActionModifier.Complete,
            details: JSON.stringify(_object_spread({
                src,
                initiatorType,
                performanceNow,
                durationSinceRequestStart: performanceNow - (requestStart - navigationStart),
                duration
            }, additionalTelemetry))
        };
        instrument.probe('logTelemetryInfo', telemetryData);
        logger.info(telemetryData.details, {
            action: telemetryData.action,
            actionModifier: telemetryData.actionModifier
        });
    });
}
export function getHostType(isEmbed) {
    const hostType = !isEmbed ? Constants.appSource : Constants.appSourceEmbed;
    return hostType;
}
export function getCTATypeForActionString(actionString) {
    if (!actionString) {
        return undefined;
    }
    const actionStrings = Object.keys(Constants.ActionStrings);
    for (const key of actionStrings){
        if (Constants.ActionStrings[`${key}`] === actionString) {
            return Constants.CTAType[`${key}`];
        }
    }
    return undefined;
}
export function logTenantInfo(users, isAutoSign, spzaUserId) {
    const instrument = SpzaInstrumentService.getProvider();
    if (users && users.signedIn && users.email) {
        let tenant = '';
        const emailParts = users.email.split('@');
        if (emailParts.length > 1) {
            tenant = emailParts[1];
        }
        // When the user is signed in, we need to correlate the spzaUserId with the signed-in information.
        // We extract the tid and oid and then map it to the spzaUserId
        const userDetails = {
            'tenant name': tenant,
            'tenand id': users.tid ? users.tid : '',
            oid: users.oid ? users.oid : '',
            spzaUserId,
            isAutoSign,
            isMSAUser: users.isMSAUser,
            userSegment: users.userSegment && UserSegment[users.userSegment] || '',
            fieldHubUserType: Constants.FieldHubUserType.None,
            emailHash: sha256(users.email).toString(),
            alternateEmailHash: users.alternateEmail && users.alternateEmail !== 'undefined' ? sha256(users.alternateEmail).toString() : '',
            tenantType: users.tenantType
        };
        const tenantPayload = {
            eventName: Constants.Telemetry.Action.UserTenantInfo,
            data: JSON.stringify(userDetails)
        };
        instrument.probe('logOneTimeInfo', tenantPayload);
        logger.info(tenantPayload.data, {
            action: tenantPayload.eventName,
            actionModifier: Constants.Telemetry.ActionModifier.Info
        });
    }
}
// This method logs the landing page details, user settings, perf
export function logInitialTelemetryEvents(store) {
    var _getWindow_location, _getWindow;
    const timeAtTelemetryMethodCall = new Date().getTime();
    const state = store.getState();
    const instrument = SpzaInstrumentService.getProvider();
    // This sets the correlationId which will be passed to the telemetry request header
    instrument.probe('initSystemInfo');
    const sharedInstrument = SharedInstrumentService.getProvider();
    // This sets the correlationId which will be passed to the telemetry request header
    sharedInstrument.probe('initSystemInfo');
    // These are one time telemetry events
    instrument.probe('logUserSystemInfo', state.config.locale);
    const { spzaUserId, newUserModifier } = getSpzaUserIdAndNewUserModifier();
    SpzaInstrumentService.registerSpzaId(spzaUserId);
    const trailIdData = getTrailIdAndData();
    SpzaInstrumentService.registerTrailId(trailIdData.trailId);
    SpzaInstrumentService.registerHostType(getHostType(state.config.isEmbedded));
    const spzaUserIDPayload = _object_spread({
        eventName: Constants.Telemetry.Action.SpzaUserId,
        actionModifier: newUserModifier,
        data: spzaUserId
    }, trailIdData);
    instrument.probe('logOneTimeInfo', spzaUserIDPayload);
    logger.info(spzaUserIDPayload.data, {
        action: spzaUserIDPayload.eventName,
        actionModifier: spzaUserIDPayload.actionModifier
    });
    // Logs user tenant info if logged in
    logTenantInfo(state.users, false, spzaUserId);
    const embedHostName = getEmbedHostName(state.config.embedHost);
    const { landingView } = state.config;
    const landingDetails = {
        landingPageURL: getWindow().location.href,
        landingView,
        referrer: getWindow().document.referrer,
        isEmbedded: state.config.isEmbedded,
        embedHost: embedHostName,
        isAuthenticated: state.users ? state.users.signedIn : '',
        cloudType: state.config.nationalCloud,
        campaign: extractCampaignsFromUrl(getWindow().location.href),
        commitHash: __COMMIT_HASH__,
        userSegment: state.users && state.users.userSegment && UserSegment[state.users.userSegment] || ''
    };
    const appName = getEntityIdFromUrl({
        pathName: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.pathname
    });
    getWindow().telemetry({
        action: Constants.Telemetry.Action.Landing,
        actionModifier: Constants.Telemetry.ActionModifier.End,
        details: landingDetails,
        spzaId: spzaUserId,
        appName
    });
    // if app data is fetched after bundle load (like power bi), the page will not be rendered on
    // component mount. There will be an additional network call to fetch app data after the
    // initial window/frame load. So defer perf event to post app data retrieval
    if (!embedHostUtils.hasDynamicData(state.config.embedHost)) {
        const timing = performance.timing;
        // Telemetry for Network Latency
        const networkLatency = timing.responseEnd - timing.fetchStart;
        // The time taken for page load once the page is received from the server
        // we may find timing.loadEventEnd as 0 if called before load event fires.
        // If so, use current time as approximation till we fix it properly
        const loadEventEnd = timing.loadEventEnd !== 0 ? timing.loadEventEnd : timeAtTelemetryMethodCall;
        // The time taken for page load once the page is received from the server
        const pageLoadTime = loadEventEnd - timing.responseEnd;
        // The whole process of navigation and page load
        // notice the inconsistent usage of time (loadEventEnd), which makes the below not too useful for me
        const navigationToPageLoad = loadEventEnd - timing.navigationStart;
        // the data we are getting here is valuable, but seems very browser specific (some browsers do not properly support)
        // so introducing a new number here that will always be consistent:
        const timePassedSinceNavigationStart = timeAtTelemetryMethodCall - timing.navigationStart;
        const perfTimings = {
            networkLatency,
            pageLoadTime,
            navigationToPageLoad,
            timePassedSinceNavigationStart,
            allTimings: timing,
            isEmbedded: state.config.isEmbedded,
            embedHost: embedHostName,
            isAuthenticated: state.users ? state.users.signedIn : '',
            // The server created state will have the count set as 0, in case we are seeing any issue,
            // wherein without going to server we see app view being loaded this well let us know.
            TelemetryLoggedCount: state.config.appViewTelemetryLoggedCount,
            landingPageURL: getWindow().location.href
        };
        const perfPayload = {
            eventName: Constants.Telemetry.Action.PerfEvents,
            data: JSON.stringify(perfTimings),
            flushLog: true
        };
        // This would dispatch an action to update the incremented count in state
        store.dispatch(createAppViewTelemetryLoggedAction(null));
        instrument.probe('logOneTimeInfo', perfPayload);
        logger.info(perfPayload.data, {
            action: perfPayload.eventName,
            actionModifier: Constants.Telemetry.ActionModifier.Info
        });
    }
}
/**
 * Sets the Profile feature flag in the state tree to true
 * @param store application state tree
 */ export function setProfileFeatureFlag(store) {
    const state = store.getState();
    // need feature flags from config
    if (!state || !state.config) {
        return;
    }
    const data = {
        page: getWindow().location.href,
        action: Constants.Telemetry.Action.EnableFeature,
        actionModifier: Constants.Telemetry.ActionModifier.Info,
        details: JSON.stringify('User Profile phone number feature enabled.')
    };
    SpzaInstrumentService.getProvider().probe('logTelemetryInfo', data);
    logger.info(data.details, {
        action: data.action,
        actionModifier: data.actionModifier
    });
    const featureFlags = _object_spread_props(_object_spread({}, state.config.featureFlags), {
        ProfileExp: 'true'
    });
    store.dispatch(createFeatureFlagsReceivedAction(featureFlags));
}
/**
 * Checks and sets whether we need to set the profileExp flag to true in the state depending on the pattern
 * @param store application state tree
 * @param pattern regular expression to apply to spza user id.
 */ export function setProfileFeatureFlagWithPattern(store, pattern) {
    const userIdInfo = getSpzaUserIdAndNewUserModifier();
    // eslint-disable-next-line security/detect-non-literal-regexp
    const profileRegex = new RegExp(pattern);
    if (matchesExpression(userIdInfo.spzaUserId, profileRegex)) {
        setProfileFeatureFlag(store);
    }
}
export function encodeVulnerableDataInInitalState(initialState) {
    const userState = initialState.users;
    userState.firstName = encodeURI(userState.firstName);
    userState.lastName = encodeURI(userState.lastName);
    userState.displayName = encodeURI(userState.displayName);
    userState.email = encodeURI(userState.email);
    userState.alternateEmail = encodeURI(userState.alternateEmail);
}
export function decodeVulnerableDataInInitalState(initialState) {
    const userState = initialState.users;
    userState.firstName = decodeURI(userState.firstName);
    userState.lastName = decodeURI(userState.lastName);
    userState.displayName = decodeURI(userState.displayName);
    userState.email = decodeURI(userState.email);
    userState.alternateEmail = decodeURI(userState.alternateEmail);
}
export function isMSASupported(products) {
    const matched = Object.values(DataMap.products).filter((product)=>!product.ShortcutFilters && bitMasksMatchFilter(products, product));
    return !!(matched.length && matched.every(({ AllowMSA })=>AllowMSA));
}
export function isAppForMSAAccountOnly(primaryProduct, products, ctaType) {
    return isOfficeApp(getPrimaryProductUrl(primaryProduct)) && !isSharepointApp(products) && ctaType === Constants.CTAType.Purchase;
}
export function getSignInModalTypeHelper(primaryProduct, products, userInfo, ctaType, isService, isTransactApp = false) {
    // If the user is in a consulting service
    if (isService) {
        // And already signed in, then we show the AAD sign in modal
        if (!userInfo.signedIn) {
            return Constants.SignInType.SignInWith_AAD;
        }
        // Otherwise, the user is already authorized.
        return Constants.SignInType.Authorized;
    }
    const isMSAUser = userInfo.isMSAUser;
    const isMSASupportedProduct = isMSASupported(products) && !isTransactApp;
    // To buy any office product other than sharepoint, the user should be signed in as a MSA user.
    const shouldForceMSA = isAppForMSAAccountOnly(primaryProduct, products, ctaType);
    if (!userInfo.signedIn) {
        if (shouldForceMSA) {
            return Constants.SignInType.SignInWith_MSA;
        } else if (isMSASupportedProduct) {
            return Constants.SignInType.SignInWith_MSA_AAD; // For WXPO products which support both
        } else {
            return Constants.SignInType.SignInWith_AAD;
        }
    }
    // already signed in as MSA and it is a transact app switch to AAD.
    if (userInfo.signedIn && isMSAUser && isTransactApp) {
        return Constants.SignInType.SwitchTo_AAD;
    }
    // If the user is not an MSA User and we have to force the user to be MSA, then we do so.
    if (userInfo.signedIn && !isMSAUser && shouldForceMSA) {
        return Constants.SignInType.SwitchTo_MSA;
    }
    // We need to switch to AAD signin dialog when :
    // 1) User is already signed in
    // 2) The product doesn't support MSA
    // 3) The user is an MSA user
    if (userInfo.signedIn && !isMSASupportedProduct && isMSAUser) {
        return Constants.SignInType.SwitchTo_AAD;
    }
    // If all the above conditions failed, it means the user is already signed in with proper authentication and can continue to Consent modal.
    return Constants.SignInType.Authorized;
}
export function getSignInModalType(primaryProduct, products, userInfo, ctaType, isService, isTransactApp = false) {
    const isServiceEntity = !!isService;
    return isServiceEntity ? getSignInModalTypeHelper(null, null, userInfo, ctaType, isServiceEntity, isTransactApp) : getSignInModalTypeHelper(primaryProduct, products, userInfo, ctaType, isServiceEntity, isTransactApp);
}
export function isAppForAdminCenter(app) {
    return !app.hideFromAdminPortal && bitMasksContainSomeBitMask(app.products, getShortCutBitmask(DataMap.products.AdminPortal)) && !(bitmaskMatch('web-apps', app.primaryProduct) && app.ctaTypes.length === 1 && app.ctaTypes[0] === Constants.CTAType.RequestTrial);
}
export function embeddedAppDataFiltering(appData, embedHost) {
    let filteredApps = appData;
    if (embedHost) {
        let appFilter = (app)=>{
            const productInfo = getProductByUrlKey({
                urlKey: embedHost
            });
            const bitmaskInfo = getProdcutBitMaskInfo(productInfo);
            return bitMasksMatchBitMask(app.primaryProduct, bitmaskInfo);
        };
        // HACK: remove after Legacy CRM EmbedHost path is fixed
        if (embedHost === Constants.dynamics365.salesED) {
            appFilter = (app)=>{
                const bitmaskInfo = getProdcutBitMaskInfo(DataMap.products.Dynamics365);
                return bitMasksMatchBitMask(app.primaryProduct, bitmaskInfo);
            };
        }
        if (embedHost === Constants.dynamics365.dynamics365) {
            appFilter = (app)=>{
                const bitmaskOperationsED = getProdcutBitMaskInfo(DataMap.products.Dynamics365forOperations);
                const bitmaskDynamics365 = getProdcutBitMaskInfo(DataMap.products.Dynamics365);
                const bitmaskFinanceAndOperationsBD = getProdcutBitMaskInfo(DataMap.products.Dynamics365forBusinessCentral);
                return bitMasksMatchBitMask(app.primaryProduct, bitmaskOperationsED) || bitMasksMatchBitMask(app.primaryProduct, bitmaskDynamics365) || bitMasksMatchBitMask(app.primaryProduct, bitmaskFinanceAndOperationsBD);
            };
        }
        if (embedHost === Constants.adminPortal) {
            appFilter = (app)=>{
                return isAppForAdminCenter(app);
            };
        }
        filteredApps = appData.filter(appFilter);
    }
    return filteredApps;
}
export function isEmailValid(email) {
    if (!email) {
        return false;
    }
    return isEmail(email);
}
// Validates whether the input is empty or not empty by trimming white spaces
// validate callback is optional for extra validation
export function isValidInput(input, validateCallBack) {
    if (input) {
        const inputNoSpaces = input.trim();
        if (inputNoSpaces.length > 0) {
            if (validateCallBack) {
                return validateCallBack(input);
            } else {
                return true;
            }
        }
    }
    return false;
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function getElement(search, key, selectorFunc) {
    let element = null;
    switch(search){
        case Constants.SearchBy.Id:
            element = document.getElementById(key);
            break;
        case Constants.SearchBy.Class:
            element = document.getElementsByClassName(key)[0];
            break;
        case Constants.SearchBy.Tag:
            element = document.getElementsByTagName(key)[0];
            break;
        case Constants.SearchBy.QuerySelector:
            {
                const elements = document.querySelectorAll(key);
                if (selectorFunc) {
                    element = selectorFunc(elements);
                } else {
                    element = elements.length > 0 ? elements[0] : null;
                }
                break;
            }
    }
    return element;
}
export function focusElementByObject(elementToFocus) {
    const element = getElement(elementToFocus.search, elementToFocus.key, elementToFocus.selectorFunc);
    if (element) {
        element.focus();
    }
    return element;
}
export function addClassToElement(search, key, className) {
    const element = getElement(search, key);
    if (element && element.classList) {
        element.classList.add(className);
    }
}
export function removeClassToFirstMatchedElement(search, key, className) {
    const element = getElement(search, key);
    if (element && element.classList) {
        element.classList.remove(className);
    }
}
export function removeClassFromElements(elementsClassName) {
    const elements = document.getElementsByClassName(elementsClassName);
    for(const clearElement in elements){
        if (elements[`${clearElement}`].classList && elements[`${clearElement}`].classList.contains(elementsClassName)) {
            elements[`${clearElement}`].classList.remove(elementsClassName);
        }
    }
}
export function focusElement(search, key) {
    const element = getElement(search, key);
    if (element) {
        element.focus();
    }
}
export function setTabindex(search, key, index) {
    const element = getElement(search, key);
    if (element) {
        element.tabIndex = index;
    }
}
export function removeTabindex(search, key) {
    const element = getElement(search, key);
    if (element) {
        element.removeAttribute(Constants.HTMLAttribute.tabIndex);
    }
}
export function addAttributes(search, key, attributes) {
    const element = getElement(search, key);
    if (element) {
        attributes.forEach((attribute)=>{
            element.setAttribute(attribute.key, attribute.value);
        });
    }
}
const postMessageLogTemplate = (msg)=>`Embed: ${msg}`;
export function postMessageToHost(payload) {
    console.log(postMessageLogTemplate('emitting telemetry before post message'));
    flushTelemetryBuffer();
    console.log(postMessageLogTemplate(`Message posted with msgType ${payload.msgType}`));
    // Added a lag of 150ms here so that when we do a handoff, the telemetry call is not failed.
    // We use this 150ms buffer to construct the telemetry call and make it before we leave SPZA portal.
    getWindow().setTimeout(()=>{
        getWindow().parent.postMessage(payload, '*');
    }, 150);
}
export function getQueryParam(req, param) {
    const value = req && req.query && req.query[`${param}`];
    return value;
}
export function getListOfDynamics365Products(productsBitmask) {
    const productsList = [];
    DataMap.products.Dynamics365.ShortcutFilters.forEach((filter)=>{
        if (bitMasksMatch(productsBitmask, DataMap.products[`${filter}`].FilterGroup, DataMap.products[`${filter}`].FilterID)) {
            productsList.push(DataMap.products[`${filter}`].Title);
        }
    });
    return productsList;
}
export function licenseDisplayTextSet(licenseType, license) {
    if (licenseType === Constants.Dynamics365LicenseType.dynamics365License) {
        if ((license.hasLicense ? 1 : 0) ^ (license.isDisputed ? 1 : 0)) {
            return Constants.dynamicsLicense.dynamics365License;
        } else {
            return Constants.dynamicsLicense.noLicense;
        }
    } else if (licenseType === Constants.Dynamics365LicenseType.dynamics365forBusinessLicense) {
        if ((license.hasLicense ? 1 : 0) ^ (license.isDisputed ? 1 : 0)) {
            return Constants.dynamicsLicense.dynamics365FinancialLicense;
        } else {
            return Constants.dynamicsLicense.noLicense;
        }
    } else {
        return '';
    }
}
export function dynamicsLicenseTypeForEmbed(productBitmask) {
    const productList = getListOfDynamics365Products(productBitmask);
    if (productList && productList.length > 0) {
        for(let i = 0; i < productList.length; i++){
            if (productList[`${i}`] === DataMap.products.Dynamics365forSales.Title || productList[`${i}`] === DataMap.products.Dynamics365forFieldServices.Title || productList[`${i}`] === DataMap.products.Dynamics365forProjectServicesAutomation.Title || productList[`${i}`] === DataMap.products.Dynamics365forCustomerServices.Title) {
                return Constants.Dynamics365LicenseType.dynamics365License;
            }
            if (productList[`${i}`] === DataMap.products.Dynamics365forBusinessCentral.Title) {
                return Constants.Dynamics365LicenseType.dynamics365forBusinessLicense;
            }
        }
    }
}
export function dynamicsLicenseType(userProfile, productsBitMask) {
    if (userProfile && userProfile.licenses && userProfile.licenses.length === Constants.dynamicsLicense.currentD365LicenseNumber) {
        return dynamicsLicenseTypeForEmbed(productsBitMask);
    } else {
        return Constants.Dynamics365LicenseType.noLicense;
    }
}
export function setInitialLocalLicenseStore(licenses, licenseType) {
    if (licenseType === Constants.Dynamics365LicenseType.dynamics365License) {
        return licenses[Constants.Dynamics365LicenseIndex.dynamics365LicenseIndex];
    } else {
        return licenses[Constants.Dynamics365LicenseIndex.dynamics365ForBusinessLicenseIndex];
    }
}
export function setInitialLicenseDisplayText(licenses, licenseType) {
    if (licenseType === Constants.Dynamics365LicenseType.dynamics365License) {
        return licenseDisplayTextSet(licenseType, licenses[Constants.Dynamics365LicenseIndex.dynamics365LicenseIndex]);
    } else {
        return licenseDisplayTextSet(licenseType, licenses[Constants.Dynamics365LicenseIndex.dynamics365ForBusinessLicenseIndex]);
    }
}
export function shouldSendUserProfile(state, isService = false) {
    const isProfileExp = state && state.config && state.config.featureFlags && state.config.featureFlags.ProfileExp === 'true';
    const userState = state && state.users;
    const isUpdateRequiredByUserBeforeSend = userState && userState.profile && userState.profile.updateRequired === false;
    return (isProfileExp || isService) && isUpdateRequiredByUserBeforeSend;
}
export function getLocaleFromState(state) {
    return !!state && !!state.config && !!state.config.locale ? state.config.locale : null;
}
/**
 * get currentView which contains curated data for Telemetry detail content
 *
 *  helper for getTelemetryDetailContentCurrentView
 *
 * @param query broser url queries
 * @param filterQueryName browser url query name
 * @param isAppGallery is application gallery page
 *
 * @return
 *  1) detailed product curated, e.g. dynamics 365 curated, office 365 curated
 *  2) detailed industry e.g. education, distribution
 *  3) empty string, if filtered view is not a industry view which shows both curated and filtered
 */ export function getTelemetryDetailContentCurrentCuratedViewPrefix(query, filterQueryName, isAppGallery) {
    const filterQueryToFilterCollectionName = {
        product: Constants.filterMaps.products,
        industry: Constants.filterMaps.industries,
        category: Constants.filterMaps.categories,
        serviceType: Constants.filterMaps.serviceTypes
    };
    const isProcessingAppGalleryIndustryFilters = isAppGallery && filterQueryName === Constants.FilterQuery.industry;
    // industy view, shows both curated and filtered, so skip adding specific keyword 'curated'
    let curatedViewPrefix = isProcessingAppGalleryIndustryFilters ? '' : 'curated';
    if (!query) {
        return curatedViewPrefix;
    }
    // get first query value of query filterQueryName
    const filterQueryValues = typeof query[`${filterQueryName}`] === 'string' && query[`${filterQueryName}`].split(';').filter((queryValue)=>!!queryValue.trim()) || [];
    const filterQueryValue = filterQueryValues[0] || '';
    if (!filterQueryValue) {
        return curatedViewPrefix;
    }
    // for industry filterd view, it also shows curated data,
    // but only when one and only one active filter is a industry filter
    // check if it is not the case, return an empty string
    if (isProcessingAppGalleryIndustryFilters) {
        const areMultipleFilterCollectionsActive = Object.keys(query).filter((queryName)=>!!DataMap[filterQueryToFilterCollectionName[`${queryName}`]]).length >= 2;
        const areMultipleIndustryFiltersActive = filterQueryValues.length >= 2;
        const querySearch = query && query[Constants.filterTileTypes.search] || '';
        const isSearchMode = !!querySearch.trim();
        if (areMultipleFilterCollectionsActive || areMultipleIndustryFiltersActive || isSearchMode) {
            // it is not a industry view which shows curated or filtered, return empty string
            return curatedViewPrefix;
        }
    }
    const filterCollection = DataMap[filterQueryToFilterCollectionName[`${filterQueryName}`]];
    if (!filterCollection) {
        return curatedViewPrefix;
    }
    Object.keys(filterCollection).some((filterName)=>{
        const filter = filterCollection[`${filterName}`];
        const match = filter.UrlKey === filterQueryValue;
        // query matches with filter url key
        if (match) {
            const filterTitle = filter.Title && filter.Title.toLowerCase() || '';
            // note using 'join', which takes care of empty filterTitle, which avoids adding a space
            curatedViewPrefix = [
                filterTitle.trim(),
                curatedViewPrefix
            ].filter((word)=>word.trim()).join(' ');
        }
        return match;
    });
    return curatedViewPrefix;
}
/**
 * get currentView for Telemetry detail content
 *
 *   additionally for gallery page, need to determine further whether it is
 *        a) curated view
 *        b) detailed product curated view (e.g. office 365 curated appGallery)
 *        c) filtered view
 *        d) industry view (e.g. education appGallery)
 *        e) search filtered view
 *
 * @param currentView current rendered view name, one of routes property `name` in routerHistory.tsx
 * @param currentGalleryViewIsCurated only applies when current view is a gallery view, determine whether it is curated
 */ export function getTelemetryDetailContentCurrentView(currentView, currentGalleryViewIsCurated) {
    if (!currentView) {
        return undefined;
    }
    // get all gallery views from routes in routerHistory.tsx
    // e.g. appGallery, serviceGallery
    const galleryViews = [
        routes.marketplace.name,
        routes.marketplaceServices.name
    ];
    // if new current view is not a gallery view
    if (galleryViews.indexOf(currentView) < 0) {
        // simply return current view
        return currentView;
    }
    // get browser url query, needed to determine curated view, also to determine whether gallery page is showing search results
    // NOTE:
    //  since this function is called in components may or may in coupled in routes
    //  which means container may or may not get props.location.query, props.params
    //  use function below to process queries
    const query = getQueryFromBrowserUrl();
    const isAppGallery = currentView === routes.marketplace.name;
    let galleryViewPrefix;
    // if gallery shows curated data, need to determine further whether it is
    //  1) product curated view, or
    //  2) curated view
    if (currentGalleryViewIsCurated) {
        galleryViewPrefix = getTelemetryDetailContentCurrentCuratedViewPrefix(query, Constants.FilterQuery.product, isAppGallery);
    } else {
        // if gallery shows filtered data, need to determine further whether it is
        //  1) filtered
        //  2) detailed industry view (shows both curated and filtered, if one and only one active filter is a industry filter)
        const querySearch = query && query[Constants.filterTileTypes.search] || '';
        galleryViewPrefix = // detailed industry view, or
        getTelemetryDetailContentCurrentCuratedViewPrefix(query, Constants.FilterQuery.industry, isAppGallery) || // simply filtered view
        (querySearch.trim() ? 'search filtered' : 'filtered');
    }
    const galleryView = [
        galleryViewPrefix,
        currentView
    ].filter((word)=>word.trim()).join(' ');
    return galleryView;
}
export function getTileDataCuratedQueryParams(queryParams) {
    if (!queryParams) {
        return {};
    }
    const tileDataCuratedQueryParams = {};
    for(const urlKey in queryParams){
        if (Constants.TileDataCuratedQueryParams[`${urlKey}`]) {
            tileDataCuratedQueryParams[`${urlKey}`] = queryParams[`${urlKey}`];
        }
    }
    return tileDataCuratedQueryParams;
}
export function getTileDataFilteredQueryParams(queryParams) {
    if (!queryParams) {
        return {};
    }
    const tileDataFilteredQueryParams = {};
    for(const urlKey in queryParams){
        if (Constants.TileDataFilteredQueryParams[`${urlKey}`]) {
            if (urlKey === Constants.TileDataFilteredQueryParams.search) {
                // Consider search when query length is properly
                if (queryParams[`${urlKey}`] && queryParams[`${urlKey}`].length > 1) {
                    tileDataFilteredQueryParams[`${urlKey}`] = queryParams[`${urlKey}`];
                }
            } else {
                tileDataFilteredQueryParams[`${urlKey}`] = queryParams[`${urlKey}`];
            }
        }
    }
    return tileDataFilteredQueryParams;
}
export function getTileDataAdditionalQueryParams(queryParams) {
    if (!queryParams) {
        return {};
    }
    const tileDataAdditionalQueryParams = {};
    for(const urlKey in queryParams){
        if (Constants.TileDataAdditionalQueryParams[`${urlKey}`]) {
            tileDataAdditionalQueryParams[`${urlKey}`] = queryParams[`${urlKey}`];
        }
    }
    // Initialize page
    tileDataAdditionalQueryParams[Constants.TileDataAdditionalQueryParams.page] = tileDataAdditionalQueryParams[Constants.TileDataAdditionalQueryParams.page] || '1';
    // Initialize country
    tileDataAdditionalQueryParams[Constants.TileDataAdditionalQueryParams.country] = (tileDataAdditionalQueryParams[Constants.TileDataAdditionalQueryParams.country] || Constants.usCountryCode).toUpperCase();
    // Initialize region
    tileDataAdditionalQueryParams[Constants.TileDataAdditionalQueryParams.region] = (tileDataAdditionalQueryParams[Constants.TileDataAdditionalQueryParams.region] || Constants.allStatesCode).toUpperCase();
    return tileDataAdditionalQueryParams;
}
export function getTileDataQueryParams(queryParams) {
    if (!queryParams) {
        return {};
    }
    const optimizedTileDataQueryParams = optimizeQueryParameters({
        queryParams
    });
    const tileDataQueryParams = _object_spread({}, getTileDataCuratedQueryParams(optimizedTileDataQueryParams), getTileDataFilteredQueryParams(optimizedTileDataQueryParams), getTileDataAdditionalQueryParams(optimizedTileDataQueryParams));
    return tileDataQueryParams;
}
export function getAppsTileDataQueryParams(queryParams) {
    const tileDataQueryParams = getTileDataQueryParams(queryParams);
    delete tileDataQueryParams[Constants.TileDataAdditionalQueryParams.country];
    delete tileDataQueryParams[Constants.TileDataAdditionalQueryParams.region];
    return tileDataQueryParams;
}
export function validateTileDataAdditionalQueryParams(queryParams) {
    const country = queryParams[Constants.TileDataAdditionalQueryParams.country];
    const region = queryParams[Constants.TileDataAdditionalQueryParams.region];
    if (country && !isString(country) || region && !isString(region)) {
        throw new Error('Country or Region query params that are not strings are not supported');
    }
}
const multipleAllowList = {
    [Constants.TileDataCuratedQueryParams.product]: true
};
export function isQueryParamsPersist(queryParams) {
    var _tileDataQueryParams_Constants_TileDataAdditionalQueryParams_country, _tileDataQueryParams_Constants_TileDataAdditionalQueryParams_region;
    const tileDataQueryParams = getTileDataAdditionalQueryParams(queryParams);
    const tileDataCuratedQueryParams = getTileDataCuratedQueryParams(queryParams);
    const tileDataFilteredQueryParams = getTileDataFilteredQueryParams(queryParams);
    let isMultiple = false;
    if (Object.keys(tileDataCuratedQueryParams).length === 1) {
        const key = Object.keys(tileDataCuratedQueryParams)[0];
        if (!(key in multipleAllowList)) {
            const value = tileDataCuratedQueryParams[`${key}`];
            isMultiple = !!((value === null || value === void 0 ? void 0 : value.indexOf(';')) > -1);
        }
    }
    let isValidated = true;
    if (Object.keys(tileDataCuratedQueryParams).length === 1) {
        const curatedUrlKey = Object.keys(tileDataCuratedQueryParams)[0];
        const curatedUrlValue = typeof tileDataCuratedQueryParams[`${curatedUrlKey}`] === 'string' ? tileDataCuratedQueryParams[`${curatedUrlKey}`].split(';') : [];
        isValidated = curatedUrlValue.every((value)=>!!getDataValuesFromUrlKey(curatedUrlKey, value));
    }
    return tileDataQueryParams[Constants.TileDataAdditionalQueryParams.page] === '1' && ((_tileDataQueryParams_Constants_TileDataAdditionalQueryParams_country = tileDataQueryParams[Constants.TileDataAdditionalQueryParams.country]) === null || _tileDataQueryParams_Constants_TileDataAdditionalQueryParams_country === void 0 ? void 0 : _tileDataQueryParams_Constants_TileDataAdditionalQueryParams_country.toLowerCase()) === Constants.usCountryCode && ((_tileDataQueryParams_Constants_TileDataAdditionalQueryParams_region = tileDataQueryParams[Constants.TileDataAdditionalQueryParams.region]) === null || _tileDataQueryParams_Constants_TileDataAdditionalQueryParams_region === void 0 ? void 0 : _tileDataQueryParams_Constants_TileDataAdditionalQueryParams_region.toLowerCase()) === Constants.allStatesCode && Object.keys(tileDataFilteredQueryParams).length === 0 && Object.keys(tileDataCuratedQueryParams).length <= 1 && !isMultiple && isValidated;
}
export function filterOutArrayFromIds(items, idField) {
    const map = {};
    return items.filter((item)=>{
        const id = item[`${idField}`] && item[`${idField}`].toString();
        return !map[`${id}`];
    });
}
export function filterInArrayFromIds(items, idField, sections, sectionIdField) {
    const map = {};
    for (const item of items){
        const id = item[`${idField}`] && item[`${idField}`].toString();
        if (id) {
            map[`${id}`] = item;
        }
    }
    const filteredItems = [];
    for (const section of sections){
        const sectionId = section[`${sectionIdField}`] && section[`${sectionIdField}`].toString();
        if (map[`${sectionId}`]) {
            filteredItems.push(map[`${sectionId}`]);
        }
    }
    return filteredItems;
}
// Convert time stamp of the form "_h_m_s" for example "1h30m10s"
export function convertTimeToSeconds(timeStamp) {
    let totalTimeInSeconds = 0;
    if (timeStamp) {
        // eslint-disable-next-line security/detect-unsafe-regex
        const hours = timeStamp.match(/(\d+)+h/);
        // eslint-disable-next-line security/detect-unsafe-regex
        const minutes = timeStamp.match(/(\d+)+m/);
        // eslint-disable-next-line security/detect-unsafe-regex
        const seconds = timeStamp.match(/(\d+)+s/);
        if (hours && hours[1]) {
            totalTimeInSeconds += parseInt(hours[1]) * 60 * 60;
        }
        if (minutes && minutes[1]) {
            totalTimeInSeconds += parseInt(minutes[1]) * 60;
        }
        if (seconds && seconds[1]) {
            totalTimeInSeconds += parseInt(seconds[1]);
        }
    }
    return isNaN(totalTimeInSeconds) ? 0 : totalTimeInSeconds;
}
export function shouldEnsureAppDetails(entityId, state) {
    const appIndex = state.apps.idMap[`${entityId}`];
    if (isNaN(appIndex)) {
        return true;
    }
    const app = state.apps.dataList[`${appIndex}`];
    if (!app) {
        return true;
    }
    if (!app.detailInformation) {
        return true;
    }
    return false;
}
export function shouldEnsureServiceDetails(entityId, state) {
    const appIndex = state.services.idMap[`${entityId}`];
    if (isNaN(appIndex)) {
        return true;
    }
    const service = state.services.dataList[`${appIndex}`];
    if (!service) {
        return true;
    }
    if (!service.detailInformation) {
        return true;
    }
    return false;
}
export function shouldEnsureAppPricings(entityId, state) {
    var _app_pricingInformation_billingRegion, _app_pricingInformation, _state_config_billingCountryCode;
    if (__SERVER__) {
        return false;
    }
    const appIndex = state.apps.idMap[`${entityId}`];
    if (isNaN(appIndex)) {
        return true;
    }
    const app = state.apps.dataList[`${appIndex}`];
    if (!app) {
        return true;
    }
    if ((app === null || app === void 0 ? void 0 : (_app_pricingInformation = app.pricingInformation) === null || _app_pricingInformation === void 0 ? void 0 : (_app_pricingInformation_billingRegion = _app_pricingInformation.billingRegion) === null || _app_pricingInformation_billingRegion === void 0 ? void 0 : _app_pricingInformation_billingRegion.toLowerCase()) === ((_state_config_billingCountryCode = state.config.billingCountryCode) === null || _state_config_billingCountryCode === void 0 ? void 0 : _state_config_billingCountryCode.toLowerCase())) {
        return false;
    }
    return true;
}
export function shouldEnsureAppReviews(entityId, state) {
    if (state.apps.appReviewsData && state.apps.appReviewsData.entityId === entityId) {
        return false;
    }
    return true;
}
export function shouldEnsureAppRelatedApps(entityId, state) {
    if (entityId === state.apps.relatedAppsItems.entityId) {
        return false;
    }
    if (state.config.embedHost === DataMap.products.PowerBICustomVisual.UrlKey) {
        return false;
    }
    return true;
}
export function shouldEnsureServiceRelatedApps(entityId, state) {
    if (entityId === state.services.relatedAppsItems.entityId) {
        return false;
    }
    return true;
}
export function isAvailableInThisRegion({ startingPrice }) {
    return !!(startingPrice && startingPrice.pricingData !== PricingStates.NotAvailableInThisRegion);
}
export function isExtensionFile(file) {
    const browsersExtensions = [
        'chrome-extension',
        'moz-extension'
    ];
    return browsersExtensions.some((browsersExtension)=>file.indexOf(browsersExtension) > -1);
}
export function windowOnErrorHandler({ msg, file, line, error }) {
    try {
        const isWarning = isExtensionFile(file);
        logClientError(error, `client side error: [From mainClientHookup] ${msg} in file ${file} on line: ${line}`, file, isWarning);
    } catch (e) {
        console.error('something went wrong during logging' + e);
    }
}
const allowedListUrlValuesCache = {
    [Constants.QueryStrings.country]: Constants.usCountryCode,
    [Constants.QueryStrings.region]: Constants.allStatesCode
};
function isAllowedListUrlValuesCache({ query = {} }) {
    return Object.entries(query).every(([key, value])=>{
        const validator = allowedListUrlValuesCache[key === null || key === void 0 ? void 0 : key.toLowerCase()];
        if (validator) {
            return (value === null || value === void 0 ? void 0 : value.toLowerCase()) === validator;
        }
        return true;
    });
}
export function generateUrlCacheKey({ isEmbedded, landingView, locale, query, isMobile = false }) {
    const urlCacheKeys = [];
    const isMainRoute = [
        Constants.Views.home,
        Constants.Views.appGallery,
        Constants.Views.serviceGallery
    ].indexOf(landingView) > -1;
    if (isMainRoute) {
        const urlParamCacheKeyBlackList = isEmbedded ? Constants.EmbedUrlParamCacheKeyBlackList : Constants.UrlParamCacheKeyBlackList;
        const isBlackListUrlCache = Object.keys(query).some((urlKey)=>urlParamCacheKeyBlackList[urlKey === null || urlKey === void 0 ? void 0 : urlKey.toLowerCase()]);
        if (!isBlackListUrlCache && isAllowedListUrlValuesCache({
            query
        })) {
            const cacheParameters = _object_spread({}, query);
            cacheParameters[Constants.QueryStrings.page] = cacheParameters[Constants.QueryStrings.page] || '1';
            if (cacheParameters[Constants.QueryStrings.page] === '1') {
                urlCacheKeys.push(landingView);
                urlCacheKeys.push(`locale:${locale === null || locale === void 0 ? void 0 : locale.toLowerCase()}`);
                urlCacheKeys.push(`isEmbedded:${isEmbedded}`);
                urlCacheKeys.push(`isMobile:${isMobile}`);
                urlCacheKeys.push(`cacheParameters:[${Object.keys(cacheParameters).filter(Boolean).filter((key)=>Constants.UrlParamCacheKeyWhiteList[key.toLowerCase()]).sort().map((key)=>`${key.toLowerCase()}:${cacheParameters[`${key}`]}`).join(',')}]`);
            }
        }
    }
    return urlCacheKeys.join('|');
}
export function getXMSClientName(appName) {
    return Constants.browserConfigsToClientNames[`${appName}`] || Constants.ClientNames.Default;
}
export function getPDPRoute(appType) {
    return isPrivateOffer(appType) ? routes.privateOfferDetails : routes.appDetails;
}
export function getGalleryRoute(appType) {
    const isPrivate = isPrivateOffer(appType);
    return {
        locKey: isPrivate ? 'UserPrivateOffers_Detail_AppTitle' : 'Embedded_Apps',
        href: isPrivate ? routes.privateOffers : routes.marketplace
    };
}
export function productsUrlValuesToSearchFilter(applicationTarget, products) {
    const searchFilter = {
        category: ISearchFilterCategory.Products,
        values: []
    };
    if (applicationTarget === Constants.appSourceApplicationTargetName && products) {
        for (const productUrlKey of products){
            const dataValues = getDataValuesFromUrlKey(Constants.TileDataCuratedQueryParams.product, productUrlKey);
            if (typeof (dataValues === null || dataValues === void 0 ? void 0 : dataValues.ShortcutUrlKey) === 'string') {
                const shortcutUrlKeys = dataValues.ShortcutUrlKey.split(';').filter((shortcutUrlKey)=>shortcutUrlKey !== (dataValues === null || dataValues === void 0 ? void 0 : dataValues.UrlKey));
                for (const shortcutUrlKey of shortcutUrlKeys){
                    const shortcutDataValues = getDataValuesFromUrlKey(Constants.TileDataCuratedQueryParams.product, shortcutUrlKey);
                    if (shortcutDataValues === null || shortcutDataValues === void 0 ? void 0 : shortcutDataValues.Title) {
                        searchFilter.values.push(shortcutDataValues.Title);
                    }
                }
            }
            if (dataValues === null || dataValues === void 0 ? void 0 : dataValues.Title) {
                searchFilter.values.push(dataValues.Title);
            }
        }
    }
    return searchFilter;
}
export function getTileDataEntityType(currentView) {
    const mapping = {
        [routes.marketplaceServices.name]: Constants.TileDataEntityType.Service,
        [routes.marketplaceCloudsIndustry.name]: Constants.TileDataEntityType.CloudsIndustry
    };
    return mapping[`${currentView}`] || Constants.TileDataEntityType.App;
}
export function getMaxPageSize(req) {
    return req.headers.searchactiontype === Constants.Search.ActionType.Suggestions ? Constants.Search.maxNumOfSuggestions : Constants.FilteredGallery.pageSize;
}
export function isService(offer) {
    return offer.entityType === Constants.EntityType.Service;
}
export function isApp(offer) {
    return offer.entityType === Constants.EntityType.App;
}
export function stripHTML(html) {
    return html.replace(Constants.removeHtmlRegex, '').trim();
}
export function isEncoded({ txt = '' } = {}) {
    return txt !== decodeURIComponent(txt);
}
export function isSignedInChanged(currentSignedIn, prevSignedIn) {
    return currentSignedIn && !prevSignedIn;
}
export function getActiveFeaturedFlags(featureFlags) {
    return Object.keys(featureFlags || {}).filter((flag)=>featureFlags[`${flag}`] === 'true' && flag !== 'ProfileExp').reduce((acc, flag)=>_object_spread_props(_object_spread({}, acc), {
            [flag]: featureFlags[`${flag}`]
        }), {});
}
export const isPlanAbleAzureApp = (app)=>{
    const products = [
        'VirtualMachine',
        'ManagedServices',
        'Container'
    ];
    return products.some((product)=>isProduct({
            app,
            product
        }));
};
export const shouldRenderPricing = ({ app, isEmbedded, billingRegion })=>{
    const { ctaTypes, licenseManagement, planPricingType } = app;
    const transactApp = isTransactApp({
        isEmbedded,
        ctaTypes,
        appData: app,
        billingRegion
    });
    const isMicrosoftManaged = !!(licenseManagement === null || licenseManagement === void 0 ? void 0 : licenseManagement.isMicrosoftManaged);
    return planPricingType !== PlanPricingType.None && (transactApp || isPlanAbleAzureApp(app) || isMicrosoftManaged);
};
export function canRenderPricing({ app, isEmbedded, billingRegion }) {
    return isEmbedded && isPowerBIVisualsApp(app) ? isBagTransactable(app) : shouldRenderPricing({
        app,
        isEmbedded,
        billingRegion
    });
}
export function shouldRenderPlanAndPricing(planPricingType) {
    return planPricingType !== PlanPricingType.None;
}
export function parseCatalogRecommendedSizes({ parameters: { osPlatform, recommendedSizes } } = {
    parameters: {
        osPlatform: '',
        recommendedSizes: []
    }
}) {
    return recommendedSizes.map((recommendedSize)=>{
        const parts = (recommendedSize || '').split('_');
        if (parts.length < 2) {
            return null;
        }
        const [tier, instance, version = '', version2 = ''] = parts;
        return [
            `${osPlatform}-${instance}${version}-${tier}`.toLowerCase(),
            `${osPlatform}-${instance}${version}${version2}-${tier}`.toLowerCase()
        ];
    }).reduce((accumulator, value)=>accumulator.concat(value), []).filter(Boolean);
}
export function sortingSKUs({ a, b }) {
    var _a_title, _b_title;
    return a.displayRank - b.displayRank || ((_b_title = b.title) === null || _b_title === void 0 ? void 0 : _b_title.toUpperCase().localeCompare((_a_title = a.title) === null || _a_title === void 0 ? void 0 : _a_title.toUpperCase()));
}
export function isProfessionalService({ service }) {
    return (service === null || service === void 0 ? void 0 : service.entityType) === Constants.EntityType.Service && (service === null || service === void 0 ? void 0 : service.isHiddenPrivateOffer);
}
export function openInNewWindow(url) {
    const newWindow = window.open(url, '_blank');
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
        var _getWindow_location, _getWindow;
        const payload = {
            page: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href,
            action: Constants.Telemetry.Action.openInNewWindow,
            actionModifier: Constants.Telemetry.ActionModifier.Error,
            details: `Failed to open the URL: ${url} in new window`
        };
        logger.error('Failed to open in new window', {
            action: payload.action,
            actionModifier: payload.actionModifier,
            page: payload.page,
            error: payload.details
        });
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
    }
}
export const getServiceTypeFromBackEndKey = (serviceTypeBackendKey)=>{
    return Object.values(DataMap.serviceTypes).find((serviceType)=>serviceType.BackendKey === serviceTypeBackendKey);
};
